import ZipCodeInput from '@carvana/showroom-forms/Input/ZipCode';
import { PrimaryButton } from '@/common/Button';
import { YellowHorizontalHero } from '@/vm/Shared/YellowHorizontal.styles';
import {
  HeroImage,
  HeroImageContent,
  VideoIframe,
  VideoWrapper,
  ZipCodeInputWrapper
} from './HeroImage.styles';
import { Header, HeaderSubText } from '../Shared/Shared.styles';

type OwnProps = {
  currentZip: string;
  onSubmit: () => void;
  onZipChange: (value: string) => void;
};

export default function HeroImageWrapper({
  currentZip,
  onSubmit,
  onZipChange
}: OwnProps) {
  return (
    <HeroImage>
      <YellowHorizontalHero />
      <HeroImageContent>
        <Header>Carvana Vending Machines</Header>
        <HeaderSubText>
          Pick up your car at one of our Vehicle Vending Machines and experience
          the new way to buy a car.
        </HeaderSubText>
        <ZipCodeInputWrapper>
          <div className="mb-20 text-center text-white tl-label-m">
            Find one near you
          </div>
          <form
            className="flex gap-8"
            onSubmit={ev => {
              ev.preventDefault();

              onSubmit();
            }}
          >
            <ZipCodeInput
              id="zipcode"
              onChange={ev => onZipChange(ev.currentTarget.value)}
              value={currentZip}
            />
            <PrimaryButton
              className="min-w-[unset]"
              size="small"
              type="submit"
              data-analytics-id="Zip Code Search"
              data-testid="zip-code-search"
            >
              GO
            </PrimaryButton>
          </form>
        </ZipCodeInputWrapper>

        <VideoWrapper>
          <VideoIframe
            title="Carvana Vending Machine"
            src="https://www.youtube.com/embed/xFVN3SN_TzE"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullscreen
          />
        </VideoWrapper>
      </HeroImageContent>
    </HeroImage>
  );
}
